import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { defaultTo } from 'ramda';

import { useAppContext } from '../../../../AppModulesWrapper';
import { selectAnalyticsProduct } from '../../../selectors/analytics';
import { selectTotalAmount, selectIsAutoProlongChecked } from '../../../selectors/checkoutInfo';
import { selectCurrentBet } from '../../../selectors/auction';
import { selectActiveServiceId } from '../../../reducers/v2/promotion/selectors';
import { selectBetPosition } from '../../../selectors/betPosition';

import { IUseAutoprolongAnalytics, ITrackAutoprolongChangeAnalyticsExtra } from '../types';

export const useAutoprolongAnalytics = (): IUseAutoprolongAnalytics => {
  const { analytics } = useAppContext();

  const product = useSelector(selectAnalyticsProduct);
  const totalAmount = useSelector(selectTotalAmount);
  const currentBet = useSelector(selectCurrentBet);
  const currentServiceId = useSelector(selectActiveServiceId)!;
  const betPosition = useSelector(selectBetPosition);
  const isAutoprolong = useSelector(selectIsAutoProlongChecked);

  const trackAutoprolongChange = useCallback(() => {
    const position = defaultTo({ offerPosition: null, page: null }, betPosition);

    analytics.send<ITrackAutoprolongChangeAnalyticsExtra>({
      action: 'Click',
      label: 'autoprolong',
      products: [product],
      extra: {
        publication_price: totalAmount.price,
        bid: currentBet,
        vas: currentServiceId,
        position: position.offerPosition,
        page_number: position.page,
        autoprolong: Number(isAutoprolong),
      },
    });
  }, [analytics, betPosition, currentBet, currentServiceId, isAutoprolong, product, totalAmount.price]);

  return { trackAutoprolongChange };
};
